export const GRANT_HEADER = 'x-record-grant';
export const LANDING_HEADER = 'x-landing-page';
